export default __webpack_public_path__ + "static/media/Wix_eCommerce.26d9fb76.png";